import {
    APPEARANCE_CHOICE_DARK,
    APPEARANCE_CHOICE_DEVICE,
    APPEARANCE_CHOICE_HIGH_CONTRAST,
    APPEARANCE_CHOICE_LIGHT,
} from './appearanceSchemes';

const TRANSLATION_PREFIX = 'evp_ticket_frontend.redesign.header.appearance';

export const APPEARANCE_LABEL_KEY = `${TRANSLATION_PREFIX}.label`;

export const SELECTED_ICON_PATH = 'M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z';

export const OPTION_ICON_SIZE = 20;
export const SELECTED_ICON_SIZE = 18;

const APPEARANCE_OPTIONS = Object.freeze([
    Object.freeze({
        choice: APPEARANCE_CHOICE_DEVICE,
        labelKey: `${TRANSLATION_PREFIX}.device`,
        iconPath: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16.01H3V4.99h18zM8 '
            + '16h2.5l1.5 1.5 1.5-1.5H16v-2.5l1.5-1.5-1.5-1.5V8h-2.5L12 6.5 10.5 8H8v2.5L6.5 12 8 '
            + '13.5zm4-7c1.66 0 3 1.34 3 3s-1.34 3-3 3z',
    }),
    Object.freeze({
        choice: APPEARANCE_CHOICE_LIGHT,
        labelKey: `${TRANSLATION_PREFIX}.light`,
        iconPath: 'M12 9c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3m0-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 '
            + '5-2.24 5-5-2.24-5-5-5M2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1m18 0h2c.55 '
            + '0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1M11 2v2c0 .55.45 1 1 1s1-.45 '
            + '1-1V2c0-.55-.45-1-1-1s-1 .45-1 1m0 18v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 '
            + '1M5.99 4.58c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 '
            + '0s.39-1.03 0-1.41zm12.37 12.37c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 '
            + '1.03.39 1.41 0 .39-.39.39-1.03 0-1.41zm1.06-10.96c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 '
            + '0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0zM7.05 18.36c.39-.39.39-1.03 '
            + '0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0z',
    }),
    Object.freeze({
        choice: APPEARANCE_CHOICE_DARK,
        labelKey: `${TRANSLATION_PREFIX}.dark`,
        iconPath: 'M9.37 5.51c-.18.64-.27 1.31-.27 1.99 0 4.08 3.32 7.4 7.4 7.4.68 0 1.35-.09 1.99-.27C17.45 17.19 '
            + '14.93 19 12 19c-3.86 0-7-3.14-7-7 0-2.93 1.81-5.45 4.37-6.49M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 '
            + '9-4.03 9-9c0-.46-.04-.92-.1-1.36-.98 1.37-2.58 2.26-4.4 2.26-2.98 0-5.4-2.42-5.4-5.4 '
            + '0-1.81.89-3.42 2.26-4.4-.44-.06-.9-.1-1.36-.1',
    }),
    Object.freeze({
        choice: APPEARANCE_CHOICE_HIGH_CONTRAST,
        labelKey: `${TRANSLATION_PREFIX}.high_contrast`,
        iconPath: 'M12 22c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10m1-17.93c3.94.49 7 3.85 7 '
            + '7.93s-3.05 7.44-7 7.93z',
    }),
]);

export function findAppearanceOption(choice) {
    return APPEARANCE_OPTIONS.find(option => option.choice === choice);
}

export default APPEARANCE_OPTIONS;
